import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from 'app/components/ui/alert-dialog';
import { Button } from 'app/components/ui/button';
import { useProductsSlice } from '../slice';
import { useEffect } from 'react';
import { toast } from 'sonner';

interface Props {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  data: any;
}
export function AlertDelete({ isOpen, onOpenChange, data }: Props) {
  const { useDeleteProductMutation } = useProductsSlice();

  const [
    deleteProduct,
    { isLoading: isDeleting, error: deleteError, data: deletedData },
  ] = useDeleteProductMutation();

  const handleDelete = () => {
    console.log(data.product_id);
    deleteProduct(data.product_id);
  };

  useEffect(() => {
    if (deleteError) {
      toast.error(deleteError?.message);
    }
  }, [deleteError]);

  useEffect(() => {
    if (deletedData) {
      toast.success(deletedData?.message);
      onOpenChange(false);
    }
  }, [deletedData]);

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete product.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} disabled={isDeleting}>
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
